import { TextVariant, TextTheme } from './types'

export const defaultTheme: TextTheme = {
  [TextVariant.TEXT_XS_REGULAR]: {
    fontFamily: 'SpaceGroteskRegular',
    fontSize: '12px',
    lineHeight: '16px'
  },
  [TextVariant.TEXT_XS_MEDIUM]: {
    fontFamily: 'SpaceGroteskMedium',
    fontSize: '12px',
    lineHeight: '16px'
  },
  [TextVariant.TEXT_XS_BOLD]: {
    fontFamily: 'SpaceGroteskBold',
    fontSize: '12px',
    lineHeight: '16px'
  },
  [TextVariant.BODY_SMALL]: {
    fontFamily: 'SpaceGroteskRegular',
    fontSize: '14px',
    lineHeight: 'normal'
  },
  [TextVariant.BODY_SMALL_BOLD]: {
    fontFamily: 'SpaceGroteskBold',
    fontSize: '14px',
    lineHeight: 'normal'
  },
  [TextVariant.BODY_SMALL_MEDIUM]: {
    fontFamily: 'SpaceGroteskMedium',
    fontSize: '14px',
    lineHeight: 'normal'
  },
  [TextVariant.BODY_DEFAULT]: {
    fontFamily: 'SpaceGroteskRegular',
    fontSize: '16px',
    lineHeight: '26px'
  },
  [TextVariant.BODY_DEFAULT_BOLD]: {
    fontFamily: 'SpaceGroteskBold',
    fontSize: '16px',
    lineHeight: '26px'
  },
  [TextVariant.BODY_DEFAULT_MEDIUM]: {
    fontFamily: 'SpaceGroteskMedium',
    fontSize: '16px',
    lineHeight: '26px'
  },
  [TextVariant.BODY_BIG]: {
    fontFamily: 'SpaceGroteskRegular',
    fontSize: '18px',
    lineHeight: '31px'
  },
  [TextVariant.BODY_BIG_BOLD]: {
    fontFamily: 'SpaceGroteskBold',
    fontSize: '18px',
    lineHeight: '31px'
  },
  [TextVariant.BODY_BIG_MEDIUM]: {
    fontFamily: 'SpaceGroteskMedium',
    fontSize: '18px',
    lineHeight: '31px'
  },
  [TextVariant.H1]: {
    fontFamily: 'SpaceGroteskBold',
    fontSize: '56px',
    lineHeight: '60px'
  },
  [TextVariant.H2]: {
    fontFamily: 'SpaceGroteskBold',
    fontSize: '48px',
    lineHeight: '60px'
  },
  [TextVariant.H3]: {
    fontFamily: 'SpaceGroteskBold',
    fontSize: '40px',
    lineHeight: '48px'
  },
  [TextVariant.H4]: {
    fontFamily: 'SpaceGroteskBold',
    fontSize: '32px',
    lineHeight: '37px'
  },
  [TextVariant.H5]: {
    fontFamily: 'SpaceGroteskBold',
    fontSize: '24px',
    lineHeight: '31px'
  },
  [TextVariant.CAPTION]: {
    fontFamily: 'SpaceGroteskRegular',
    fontSize: '16px',
    lineHeight: '25px',
    textTransform: 'uppercase'
  },
  // Additional styles applied when isTrimmed prop is passed
  // Don't recommended to use as a variant itself as it doesn't have additional styling
  [TextVariant.TRIMMED]: {
    overflow: 'hidden',
    display: '-webkit-inline-box',
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-all'
  },
  [TextVariant.HIGHLIGHTED]: {
    fontFamily: 'SpaceGroteskBold',
    backgroundImage:
      '-webkit-linear-gradient(66.11deg, #fc4f91 10.45%, #c857b9 25.48%,#7763f6 49.21%,#5387ed 61.07%,#1fbddf 80.06%,#0ad2da 89.55%)',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent'
  },
  [TextVariant.BUTTON]: {
    fontFamily: 'SpaceGroteskBold',
    fontSize: '16px',
    lineHeight: '24px'
  }
}
